import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { fetchCmsItems } from '../lib/cms'
import DestinationCard from '../components/DestinationCard'

export default function DestinationsPage() {
  const [destinations, setDestinations] = useState([])

  useEffect(() => {
    document.title = 'Destinationer - SKI & CO TRAVEL ApS'
    async function loadDests() {
      const data = await fetchCmsItems('destinationer')
      setDestinations(data)
    }
    loadDests()
  }, [])

  const favoritesList = [
    { name: 'St. Anton', land: 'ØSTRIG', hoejde: '1.304 → 2.811 M', slug: 'st-anton' },
    { name: 'Sölden', land: 'ØSTRIG', hoejde: '1.377 → 3.340 M', slug: 'soelden' },
    { name: 'Saalbach–Hinterglemm', land: 'ØSTRIG', hoejde: '1.003 → 2.096 M', slug: 'saalbach' },
    { name: 'Ischgl', land: 'ØSTRIG', hoejde: '1.377 → 2.872 M', slug: 'ischgl' },
    { name: 'Zauchensee', land: 'ØSTRIG', hoejde: '1.000 → 2.188 M', slug: 'zauchensee' },
    { name: 'Schladming', land: 'ØSTRIG', hoejde: '745 → 2.015 M', slug: 'schladming' },
    { name: 'Canazei', land: 'ITALIEN', hoejde: '1.465 → 2.640 M', slug: 'canazei' },
  ]

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 space-y-16">
      {/* Header */}
      <div className="space-y-4 max-w-3xl">
        <span className="text-xs font-bold uppercase tracking-widest text-cyan-400">
          DESTINATIONER
        </span>
        <h1 className="font-heading font-extrabold text-2xl sm:text-4xl text-white">
          Vores favoritter i Alperne
        </h1>
        <p className="text-slate-300 text-base sm:text-lg leading-relaxed">
          Udforsk vores håndplukkede skiområder i Østrig, Italien, Frankrig og Norge. Alle destinationer er udvalgt for deres fantastiske skiløb, snesikkerhed og unikke atmosfære.
        </p>
      </div>

      {/* Favorites Altitude Cards */}
      <div className="bg-slate-900 border border-slate-800 rounded-3xl p-6 sm:p-8 space-y-6 shadow-2xl">
        <div className="space-y-2">
          <h2 className="font-heading font-bold text-lg sm:text-xl text-white">
            Favoritområder & Terrænhøjder
          </h2>
          <p className="text-xs sm:text-sm text-slate-400">
            Første tal er byens/dalstationens højde, andet tal er den højeste skiheis i området — et fingerpeg om terrænet. Vi tager lige så gerne fat på jeres ønskedestination andre steder i Alperne.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {favoritesList.map((fav, i) => (
            <div
              key={i}
              className="bg-slate-950 p-4 rounded-2xl border border-slate-800/80 hover:border-cyan-500/40 transition-colors flex items-center justify-between"
            >
              <div>
                <div className="text-xs font-bold font-mono text-cyan-400">{fav.land}</div>
                <div className="font-heading font-bold text-base text-white">{fav.name}</div>
              </div>
              <div className="text-right">
                <span className="text-xs font-mono font-semibold px-2.5 py-1 rounded-lg bg-slate-800 text-slate-200 border border-slate-700/60 inline-block">
                  {fav.hoejde}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* All Destination Cards */}
      <div className="space-y-6">
        <h2 className="font-heading font-bold text-2xl text-white">
          Alle udvalgte skiområder
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {destinations.map((dest) => (
            <DestinationCard key={dest.id} destination={dest} />
          ))}
        </div>
      </div>
    </div>
  )
}
